<template>
  <div class="search_area">
    <div class="title">
      Search
    </div>
    <div class="radio_label">
      <span v-for="(item, index) in ExchangeSearch" :key="index" class="radio_list">
        <ExchangeRadioItem
          class="radio_item"
          :paymentId="parseInt(index)"
          :name="item"
          :isChecked="currentIndex == index"
          @handleRadioBtnClick="handleRadioBtnClick"
        />
      </span>
    </div>
    <div class="text_area">
      <TextBox
        class="text-box"
        inputType="text"
        placeholder="Card name, rarity, and model number"
        v-model="searchText"
      />
      <BlackGradationButton
        class="black-gradation-button"
        text="Search"
        @handleSquareBtnClick="clickSearch"
      />
    </div>
  </div>
</template>
<script>
import ExchangeRadioItem from '@/components/molecules/ExchangeRadioItem.vue';
import TextBox from '@/components/atoms/TextBox.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import { ExchangeSearch } from '@/common/config/js/const';

export default {
  name: 'ExchangeSearchArea',
  components: {
    ExchangeRadioItem,
    TextBox,
    BlackGradationButton,
  },
  data: () => ({
    ExchangeSearch,
    currentIndex: 0,
    searchText: '',
  }),
  props: {
    serachParams: {
      type: Object,
    },
  },
  methods: {
    handleRadioBtnClick(paymentId) {
      this.currentIndex = paymentId;
    },
    clickSearch() {
      this.serachParams.searchText = this.searchText;
      this.serachParams.sort = this.currentIndex;
      this.$emit('clickSearch', this.serachParams);
    },
  },
};
</script>
<style lang="scss" scoped>
.search_area {
  .title {
    color: white;
  }
  .radio_label {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
  .text_area {
    margin-top: 20px;
    display: flex;
    padding: 20px;
    .text-box {
      flex: 1;
    }
    .black-gradation-button {
      width: 100px;
      margin-left: 20px;
    }
  }
}
@media screen and (max-width: 768px) {
  .search_area {
    .radio_label {
      padding: 0 10px;
    }
    .text_area {
      margin-top: 10px;
    }
  }
}
</style>
